import {z} from 'zod';

import i18n from '@dms/i18n';
import {zodPasswordValidation} from '@dms/shared';

export const ChangePasswordSchema = z
  .object({
    currentPassword: z
      .string({required_error: i18n.t('general.validations.fieldIsRequired')})
      .min(1, i18n.t('general.validations.fieldIsRequired')),
    newPassword: zodPasswordValidation,
    confirmPassword: z
      .string({required_error: i18n.t('general.validations.fieldIsRequired')})
      .min(1, i18n.t('general.validations.fieldIsRequired')),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: i18n.t('general.notifications.errorPasswordsNotMatch'),
    path: ['confirmPassword'],
  });

export type ChangePasswordSchemaType = z.infer<typeof ChangePasswordSchema>;
